import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <h3>F Square Contracting</h3>
              <p className="footer-tagline">Professional Electrical Services</p>
            </div>
            <p className="footer-description">
              Serving India for over 3 years with professional electrical services. 
              Your trusted partner for reliable, quality electrical solutions.
            </p>
            <div className="footer-certifications">
              <span className="certification">💯 Quality</span>
              <span className="certification">🛡️ Safety</span>
              <span className="certification">🔒 Reliability</span>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Services</h4>
           <ul className="footer-links">
              <li><a href="#services">Electrical Installation</a></li>
              <li><a href="#services">Concealed & Open Conduit Wiring</a></li>
              <li><a href="#services">All kinds of Conduit Laying</a></li>
              <li><a href="#services">Distribution Board Installation & Dressing</a></li>
              <li><a href="#services">Panel Board Installation</a></li>           
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#contact">Contact</a></li>              
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="footer-contact">
              <div className="contact-detail">
                <span className="contact-label">📞 Phone:</span>
                <a href="tel:+918056177577">+91 80561 77577</a>
              </div>
              <div className="contact-detail">
                <span className="contact-label">✉️ Email:</span>
                <a href="mailto:info@fsquare.biz">info@fsquare.biz</a>
              </div>
              <div className="contact-detail">
                <span className="contact-label">📍 Address:</span>
                <span>No. 183 & 184, 1st Floor,
9th street, Selliamman Nagar, Vellanoor Village, Arikkambedu, Chennai- 600 062 </span>
              </div>            
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">
              © {currentYear} F Square Contracting. All rights reserved.
            </p>
            <div className="footer-bottom-links">
              <a href="#privacy">Privacy Policy</a>
              <a href="#terms">Terms of Service</a>
              <a href="#sitemap">Sitemap</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
